import React, { useState } from 'react'
import { Table, TableComponent } from 'components/Table'

export default function Eventos() {
  const [TableData] = useState(
    Table.Data([
      Table.Field('idpropietario', 'Propietario'),
      Table.Field('nombre', 'Nombre'),      
    ], [
      ...Table.DefaultActions(),
    ],
      Table.Config('evento', 'nombre', 'idevento')
    )
  )
  
  return (
    <div>
      <h2>Eventos</h2>
      <TableComponent
        data={TableData}
      />
    </div>
  )
}
